import { dispatch } from 'oasis-os-react';
import { getPlaylistListByUri, getUserPlaylistItems } from './index';
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (playlists, type) => {
    // eslint-disable-next-line sonarjs/no-ignored-return
    playlists.reduce(async (accumulatorPromise, nextPlaylist) => {
        await accumulatorPromise;
        // eslint-disable-next-line @typescript-eslint/no-misused-promises,no-async-promise-executor
        let apiCall;
        let key;
        switch (type) {
            case 'getShares':
                apiCall = getPlaylistListByUri;
                key = 'uri';
                break;
            case 'getShareResources':
                apiCall = getPlaylistListByUri;
                key = 'location';
                break;
            case 'eSearch':
                apiCall = getPlaylistListByUri;
                key = 'uri';
                break;
            default:
                apiCall = getUserPlaylistItems;
                key = 'uid';
                break;
        }
        return new Promise(async (resolve) => {
            const playlistItem = await apiCall(nextPlaylist[key], {
                start: 1,
                count: 1,
                sort: 'elementorder+asc',
            });
            if (playlistItem.data.length) {
                await dispatch('*', 'playlistCoverLoaded', nextPlaylist, playlistItem.data[0]);
            }
            resolve();
        });
    }, Promise.resolve());
};
